import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { makeTextPatch } from '../../utils/templates';
import { ContentAdvisory } from '../rating/contentAdvisory.component';
import { colors, defaultContext, getInitialStyle } from './programDescription.style';

export class ProgramDescription extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Highlight: {},
        ContentAdvisory: {
          type: ContentAdvisory,
        },
        Description: {},
        Details: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _attach() {
    [this.tag('Description'), this.tag('Details')].forEach(child => {
      child.onUpdate = () => {
        if (this._emittedHeight !== this.finalH) {
          this._emittedHeight = this.finalH;
          this.emit('txLoaded');
        }
      };
    });
  }

  _detach() {
    this.tag('Description').onUpdate = undefined;
    this.tag('Details').onUpdate = undefined;
    this._emittedHeight = 0;
  }

  set data(value) {
    const { description, details, highlight, extraHighlight, contentAdvisory } = value;
    const { colorMode } = this._style;
    const icons = (contentAdvisory ? contentAdvisory.pictos : []).filter(Boolean);

    this.patch({
      Highlight: makeTextPatch(highlight, this.w, colors.highlight[colorMode]),
      ContentAdvisory: {
        visible: Boolean(extraHighlight || icons.length),
        data: {
          icons,
          label: extraHighlight,
        },
      },
      Description: makeTextPatch(description, this.w, colors.description[colorMode]),
      Details: makeTextPatch(details, this.w, colors.details[colorMode]),
    });
  }
}
